import React, { useState, useEffect, useRef } from "react";
import Api from "../../../../_helpers/Api";
import { useParams, useHistory, Link } from "react-router-dom";
import { trans } from "../../../../_providers/Translation";
import {
  buildSharedApiUrl,
  buildSharedApiData,
} from "../../../../_helpers/SharedParams";

//modals
import AddEditModal from "./modals/AddEditTodo";
import TodoModal from "../../todo/partials/modals/View";
import QuestionModal from "../../../modals/messages/Question";

//images
import loader from "../../../../assets/img/loader.svg";
import checkIcon from "../../../../assets/img/icons/check.png";
import notFound from "../../../../assets/img/not-found.png";

//partials
import TodoMenu from "./TodoMenu";

function Todo(props) {
  const [table, setTable] = useState({
    options: null,
    data: [],
    loading: true,
  });

  let params = useParams().id;
  const history = useHistory();

  //refs
  const addEditModalRef = useRef(null);
  const questionModalRef = useRef(null);
  const todoModalRef = useRef(null);

  useEffect(() => loadData(), []);

  const loadData = () => {
    // Build API URL with shared parameters
    const url = buildSharedApiUrl(
      `reservations/todos?id=${params}`,
      props.sharedParams,
    );

    Api.get(url).then((res) => {
      setTable((table) => ({
        ...table,
        data: res.data,
        loading: false,
      }));
    });
  };

  const handleSuccessAdd = () => loadData();

  const handleView = (data) => todoModalRef.current.open(data);

  const handleDelete = (id) => questionModalRef.current.open(id);

  const handleConfirmDelete = (id) => {
    const deleteData = buildSharedApiData(
      {
        id: params,
        todo_id: id,
      },
      props.sharedParams,
    );

    Api.post("reservations/todos/delete", deleteData).then(() => {
      // Preserve existing URL parameters while updating tab and indicator
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set("tab", "todo");
      currentParams.set("indicator", new Date().getTime().toString());
      history.push(`?${currentParams.toString()}`);
    });

    let newData = table.data.filter((row) => {
      return row.id != id;
    });

    setTable((table) => ({
      ...table,
      data: newData,
    }));
  };

  const handleAddTodo = () => addEditModalRef.current.open();

  const handleEdit = (id) => addEditModalRef.current.open(id);

  const handleRead = (id) => {
    const readData = buildSharedApiData(
      {
        id: id,
      },
      props.sharedParams,
    );

    Api.post("todos/mark-as-read", readData).then((res) => {
      let newData = table.data.map((each) => {
        if (each.id == id) {
          each = res.data;
        }

        return each;
      });

      setTable((prev) => ({
        ...prev,
        data: newData,
      }));
    });
  };

  const handleComplete = (id) => {
    const completeData = buildSharedApiData(
      {
        id: id,
      },
      props.sharedParams,
    );

    Api.post("todos/mark-as-completed", completeData).then((res) => {
      let newData = table.data.map((each) => {
        if (each.id == id) {
          each = res.data;
        }

        return each;
      });

      setTable((prev) => ({
        ...prev,
        data: newData,
      }));
    });
  };

  return (
    <div id="reservation-todo">
      <AddEditModal
        ref={addEditModalRef}
        callback={handleSuccessAdd}
        sharedParams={props.sharedParams}
        reservationData={props.data}
      />

      <TodoModal ref={todoModalRef} handleRead={handleRead} />

      <QuestionModal
        ref={questionModalRef}
        mainMessage={trans("headings.question6")}
        secondaryMesasge={trans("subheadings.confirmDelete")}
        callback={handleConfirmDelete}
      />

      <div className="pannel">
        <div className="head">
          <div className="left">{trans("tabs.todo")}</div>
          <div className="right">
            {props.data.can_modify && (
              <button
                className="button button-add button-small"
                onClick={handleAddTodo}
              >
                {trans("buttons.newTodo")}
              </button>
            )}
          </div>
        </div>
        {table.loading ? (
          <img src={loader} alt="loading" />
        ) : table.data.length == 0 ? (
          <div className="not-found">
            <img src={notFound} alt="Not Found" />
            <p>{trans("messages.noResultsFound")}</p>
          </div>
        ) : (
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  <th className="todo-check"></th>
                  <th>ID</th>
                  <th>{trans("tables.createdBy")}</th>
                  <th>{trans("tables.setTo")}</th>
                  <th>{trans("tables.reservation")}</th>
                  <th>{trans("tables.heading")}</th>
                  <th>{trans("tables.datePriority")}</th>
                  <th>{trans("tables.deadline")}</th>
                  {props.data.can_modify && (
                    <th className="options">{trans("tables.options")}</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {table.data.map((each) => (
                  <tr key={each.id}>
                    <td className="todo-check">
                      {each.completed_at && (
                        <img src={checkIcon} alt="completed" />
                      )}
                    </td>
                    <td>{each.id}</td>
                    <td>
                      {each.shared
                        ? `${each.shared_by_partner_name} (${trans('labels.partner')})`
                        : `${each.author?.name ?? ""} ${each.author?.lastname ?? ""}`}
                    </td>
                    <td>
                      {each.tags
                        .map((tag) => {
                          return tag.employee
                            ? `${tag.employee?.name} ${tag.employee?.lastname ?? ""}`
                            : "";
                        })
                        .filter((each) => each !== "")
                        .join(", ")}
                    </td>
                    <td>
                      <Link
                        to={(() => {
                          const currentParams = new URLSearchParams(
                            window.location.search,
                          );
                          currentParams.set("tab", "info");
                          return `?${currentParams.toString()}`;
                        })()}
                      >
                        {each.reservation.reference_code}
                      </Link>
                    </td>
                    <td>{each.title}</td>
                    <td>
                      {each.date_dmy}{" "}
                      {each.priority && (
                        <>
                          {" "}
                          /{" "}
                          <p className="priority-holder">
                            <span
                              className={`priority ${each.priority.name == "low" ? "low" : each.priority.name == "normal" ? "medium" : "high"}`}
                            ></span>
                            {each.priority.translation?.name}
                          </p>
                        </>
                      )}
                    </td>
                    <td>{each.deadline_dmy}</td>
                    {props.data.can_modify && (
                      <TodoMenu
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleView={handleView}
                        handleComplete={handleComplete}
                        isCompleted={each.completed_at}
                        canMarkAsCompleted={each.can_mark_as_completed}
                        each={each}
                        options={table.options}
                      />
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Todo;
